import React from 'react';

const CallbackSection = () => {
  return (
    <section className="callback-section">
      <div className="container">
        <div className="row no-gutters align-items-center">
          
          {/* Left Image + Video Button */}
          <div className="col-lg-5">
            <div
              className="callback-img"
              style={{ backgroundImage: 'url(/images/img8.jpg)' }}
            >
          
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-7">
            <div className="callback-inner">
              {/* Section Heading */}
              <div className="section-heading section-heading-white">
                <h5 className="dash-style">WHY CHOOSE US</h5>
                <h2>SAFE. RELIABLE. AFFORDABLE RIDES</h2>
                <p>
                  At Prince Cabs, we provide premium taxi and cab services across the city and beyond. Whether you're commuting, traveling to the airport, or planning a family trip — we've got you covered 24/7 with our well-maintained vehicles and professional drivers.
                </p>
              </div>

              {/* Counters */}
              <div className="callback-counter-wrap">
                <div className="counter-item">
                  <div className="counter-icon">
                    <img src="/images/icon1.png" alt="Satisfied Clients Icon" />
                  </div>
                  <div className="counter-content">
                    <span className="counter-no"><span className="counter">500</span>K+</span>
                    <span className="counter-text">Happy Customers</span>
                  </div>
                </div>

                <div className="counter-item">
                  <div className="counter-icon">
                    <img src="/images/icon2.png" alt="Rides Completed Icon" />
                  </div>
                  <div className="counter-content">
                    <span className="counter-no"><span className="counter">250</span>K+</span>
                    <span className="counter-text">Successful Rides</span>
                  </div>
                </div>

                <div className="counter-item">
                  <div className="counter-icon">
                    <img src="/images/icon3.png" alt="Fleet Size Icon" />
                  </div>
                  <div className="counter-content">
                    <span className="counter-no"><span className="counter">100</span>+</span>
                    <span className="counter-text">Fleet Vehicles</span>
                  </div>
                </div>

                <div className="counter-item">
                  <div className="counter-icon">
                    <img src="/images/icon4.png" alt="Daily Bookings Icon" />
                  </div>
                  <div className="counter-content">
                    <span className="counter-no"><span className="counter">30</span>+</span>
                    <span className="counter-text">Daily Bookings</span>
                  </div>
                </div>
              </div>

              {/* Support Area */}
              <div className="support-area">
                <div className="support-icon">
                  <img src="/images/icon5.png" alt="Support Icon" />
                </div>
                <div className="support-content">
                  <h4>24/7 Customer Support</h4>
                  <h3>
                    <a href="tel:+919284304420">Call: +91 9284304420</a> <br/>
                    <a href="tel:+918308844163">Call: +91 8308844163</a>
                  </h3>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CallbackSection;
